import React, { useState } from "react";
// import { useForm } from "react-hook-form";
import {
  StyledFileInput,
  StyledInput,
  StyledInputContainer,
  StyledInputGroup,
  StyledLabel,
  StyledUploadLabel,
  StyledSelect,
  StyledSelectContainer,
  StyledSelectGroup,
  SelectLabel,
} from "../../StyledCss/styledInputs";
import { PrimaryButton, SecondaryButton } from "../../StyledCss/styledbtn";
import { uploadPolicyPdf, updatePolicyPdf, getUserData } from "../../api/services/hroneApi";
import UploadingLoader from "../UploadingLoader";
import { ErrorText } from "../../StyledCss/styledComponents";
import "./policyform.css";
import toast from "react-hot-toast";

const apiStatusConstants = {
  initial: "INITIAL",
  success: "SUCCESS",
  failure: "FAILURE",
  inProgress: "IN_PROGRESS",
};

const AddPolicyForm = ({ getPolicies, closeModal, isEditMode = false, editingPolicy = null, onSuccess }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadPdfError, setUploadPdfError] = useState("");
  const [apiStatus, setApiStatus] = useState(apiStatusConstants.initial);
  const [policyName, setPolicyName] = useState(isEditMode ? (editingPolicy?.policyName || "") : "");

  const [fileUploadButtonDisabled, SetFileUploadButtonDisabled] = useState(isEditMode);
  const [fileSizeError, setFileSizeError] = useState("");
  const [visibleToError, setVisibleToError] = useState("");

  const getInitialVisibleTo = () => {
    if (!isEditMode || !editingPolicy?.visibleTo) return "";
    return editingPolicy.visibleTo;
  };
  const [visibleTo, setVisibleTo] = useState(getInitialVisibleTo);

  const editDisplayFileName = isEditMode && editingPolicy?.policyUrl
    ? editingPolicy.policyUrl.split("/").pop().split("?")[0]
    : "";

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!visibleTo) {
      setVisibleToError("Please select visibility.");
      return;
    }
    if (isEditMode) {
      try {
        setApiStatus(apiStatusConstants.inProgress);
        const policyObj = new FormData();
        policyObj.append("id", editingPolicy.id);
        if (policyName !== editingPolicy.policyName) {
          policyObj.append("policy_name", policyName);
        }
        if (visibleTo !== editingPolicy.visibleTo) {
          policyObj.append("visible_to", visibleTo);
        }
        if (selectedFile) {
          policyObj.append("policy_file", selectedFile);
        }
        const boundary = `Boundary-${Math.random().toString(16).substring(2)}`;
        const response = await updatePolicyPdf(policyObj, boundary);
        if (response.status === 200) {
          toast.success("Policy Updated Successfully");
          setApiStatus(apiStatusConstants.success);
          onSuccess?.();
          closeModal();
          getPolicies();
        }
      } catch (error) {
        const message = error?.response?.data?.message || "Error Updating Policy";
        setUploadPdfError(message);
        setApiStatus(apiStatusConstants.failure);
      }
      return;
    }
    setUploadPdfError("");
    try {
      setApiStatus(apiStatusConstants.inProgress);
      const policyObj = new FormData();
      policyObj.append("policy_name", policyName);
      policyObj.append("policy_file", selectedFile);
      policyObj.append("visible_to", visibleTo);

      const boundary = `Boundary-${Math.random().toString(16).substring(2)}`;

      const response = await uploadPolicyPdf(policyObj, boundary);
      if (response.status === 200) {
        const { role } = getUserData();
        toast.success(
          role === "HR" ? "Policy sent for approval" : "Policy Uploaded Successfully"
        );
        setApiStatus(apiStatusConstants.success);
        onSuccess?.();
        closeModal();
        getPolicies();
      }
    } catch (error) {
      const message = error?.response?.data?.message || "Error Uploading File";
      setUploadPdfError(message);
      setApiStatus(apiStatusConstants.failure);
    }
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file !== undefined) {
      setSelectedFile(file);
      SetFileUploadButtonDisabled(true);
      if (file.size > 1 * 1024 * 1024) {
        setFileSizeError("File size exceeds 1MB limit.");
      } else {
        setFileSizeError("");
        setUploadPdfError("");
      }
    }
  };

  const onHandlePolicyName = (e) => {
    setPolicyName(e.target.value);
  };

  const hasValue = (selectedFile !== null && selectedFile.name !== "") || (isEditMode && !!editDisplayFileName);

  return (
    <div>
      <form onSubmit={onSubmit}>
        <div style={{ display: "flex", gap: "16px", alignItems: "flex-start" }}>
          <StyledInputGroup style={{ flex: 1, marginBottom: 0 }}>
            <StyledInputContainer>
              <StyledInput
                autoComplete="off"
                type="text"
                id="policy name"
                value={policyName}
                onChange={onHandlePolicyName}
                style={{ width: "100%" }}
              />
              <StyledLabel className="user-label">Policy Name*</StyledLabel>
            </StyledInputContainer>
          </StyledInputGroup>

          <StyledSelectGroup style={{ flex: 1 }}>
            <StyledSelectContainer>
              <StyledSelect
                value={visibleTo}
                onChange={(e) => { setVisibleTo(e.target.value); setVisibleToError(""); }}
                width="100%"
              >
                <option value="" disabled>Select</option>
                <option value="HR">HR</option>
                <option value="ALL">All</option>
              </StyledSelect>
              <SelectLabel>Visible To *</SelectLabel>
            </StyledSelectContainer>
            {visibleToError && <ErrorText>*{visibleToError}</ErrorText>}
          </StyledSelectGroup>
        </div>

        <div className="btns-container d-flex gap-3">
          {!selectedFile && (
            <StyledFileInput
              accept=".pdf"
              onChange={handleFileSelect}
              id="fileInput"
              type="file"
              disabled={fileUploadButtonDisabled}
            />
          )}
          <StyledUploadLabel
            disabled={fileUploadButtonDisabled}
            htmlFor="fileInput"
            id="uploadBtn"
            style={
              fileUploadButtonDisabled
                ? { color: "#999999" }
                : { backgroundColor: "#E86020", color: "#ffffff" }
            }
          >
            Upload
          </StyledUploadLabel>

          <StyledInputGroup>
            <StyledInputContainer>
              <StyledInput
                value={selectedFile !== null ? selectedFile.name : editDisplayFileName}
                readOnly
                type="text"
                autoComplete="off"
              />
              <StyledLabel hasValue={hasValue} className="user-label">
                File Name
              </StyledLabel>
            </StyledInputContainer>
          </StyledInputGroup>

          <SecondaryButton
            type="button"
            onClick={() => {
              setSelectedFile(null);
              setFileSizeError("");
              SetFileUploadButtonDisabled(false);
            }}
          >
            Cancel
          </SecondaryButton>
        </div>

        <div className="d-flex justify-content-end gap-3 mt-3">
          <SecondaryButton type="button" onClick={closeModal}>
            Cancel
          </SecondaryButton>
          <PrimaryButton
            className="uploadBtn-2"
            disabled={isEditMode ? !policyName.trim() : (!selectedFile || !policyName.trim() || !!fileSizeError)}
            type="submit"
          >
            {isEditMode ? "Update" : "Add"}
          </PrimaryButton>
        </div>
        {fileSizeError && <ErrorText>*{fileSizeError}</ErrorText>}
        {uploadPdfError && <ErrorText>*{uploadPdfError}</ErrorText>}
        {apiStatus === apiStatusConstants.inProgress && <UploadingLoader />}
      </form>
    </div>
  );
};

export default AddPolicyForm;
